import React from "react";
import "./loader.css";

export default function Loader() {
  return (
    <div id="loader-overlay" aria-busy="true" aria-label="Cargando...">
      <div className="loader-container">
        <div className="glow-bg" aria-hidden="true" />
        <div className="spinner-ring">
          <div className="ring ring-1" />
          <div className="ring ring-2" />
          <div className="inner-pulse" />
        </div>
        <div className="loader-label">Cargando</div>
        <div className="particles" aria-hidden="true">
          <span className="dot d1" />
          <span className="dot d2" />
          <span className="dot d3" />
        </div>
      </div>
    </div>
  );
}
